var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-container"},[_c('img',{attrs:{"src":require("../../assets/img/DA6E6E8E-8C90-4A35-A8DF-42C4FF236395.png")}})])
}]

export { render, staticRenderFns }